import { render } from "./terminalView.vue?vue&type=template&id=2e980330&scoped=true"
import script from "./terminalView.vue?vue&type=script&lang=js"
export * from "./terminalView.vue?vue&type=script&lang=js"

import "./terminalView.vue?vue&type=style&index=0&id=2e980330&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e980330"]])

export default __exports__